import { noop } from "lodash";
import type { ButtonElement as ButtonElementType } from "@/react/types/Element";
import { Button } from "@circle-react-uikit/Button";

interface ButtonElementProps {
  // eslint-disable-next-line sonarjs/no-redundant-optional -- Disabled for plugin version update. Fix when possible.
  className?: string | undefined;
  element: ButtonElementType;
  isPreview: boolean;
  isSubmitting: boolean;
}
export const ButtonElement = ({
  element,
  isPreview = false,
  isSubmitting = false,
  className,
}: ButtonElementProps) => (
  <Button
    variant="circle"
    full
    large
    className={className}
    type={isPreview ? "button" : "submit"}
    disabled={isSubmitting}
    onClick={isPreview ? noop : undefined}
    style={{
      color: element.attributes.text_color,
      backgroundColor: element.attributes.background_color,
      borderColor: element.attributes.background_color,
    }}
  >
    {element.attributes.label}
  </Button>
);
